import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cam-tools-outline",
  "use": "cam-tools-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cam-tools-outline\"><path d=\"M12 4.15 6.04 7.5 12 10.85l5.96-3.35zM13 20v2h-2v-2zm4-2v2h-2v-2zm-8 0v2H7v-2zm4-2v2h-2v-2zm8 0v2h-2v-2zM5 16v2H3v-2zm7-14c.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88V14h-2V9.21l-6 3.37V14h-2v-1.42L5 9.21V14H3V7.5c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18z\" fill-rule=\"evenodd\" />&gt;</symbol>"
});
var result = sprite.add(symbol);
export default symbol